import React from "react";

export default function Footer() {
  return (
    <footer className="footer">
      <p className="footer__info section-width">
        The theme created by{" "}
        <a href="mailto:emirsagit@gmail.com" className="footer__link">
          Emir Sagit.
        </a>
      </p>
    </footer>
  );
}
